<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">供应商编号：</span>
        <el-input v-model="search.supplierNo" :size="size" clearable placeholder="请输入供应商编号"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">供应商类型：</span>
        <el-select v-model="search.supplierType" placeholder="请选择供应商类型" clearable>
            <el-option
            v-for="item in optionsSupplierType"
            :key="item.dictId"
            :label="item.dictName"
            :value="item.dictId">
            </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <span class="header_label" style="width:180px">供应商企业名称：</span>
        <el-input v-model="search.supplierName" :size="size" clearable placeholder="请输入供应商企业名称"></el-input>
      </div>
      <div class="header_item">
        <el-button  icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="supplierNo" label="供应商编号" align="center" width="120"></el-table-column>
        <el-table-column prop="dictName" label="供应商类型" align="center" width="120"></el-table-column>
        <el-table-column prop="supplierName" label="供应商企业名称" align="center" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="legalPerson" label="法定代表人" align="center" width="150"></el-table-column>
        <el-table-column prop="succ" label="统一社会信用代码" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contact" label="联系人" align="center" width="120"></el-table-column>
        <el-table-column prop="contactPhone" label="联系电话" align="center" width="150"></el-table-column>
        <el-table-column prop="email" label="电子邮箱" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="project" label="项目名称" align="center" show-overflow-tooltip>
            <template #default="{row}">
                <div>{{showProject(row.supplierPros)}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="address" label="公司地址" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增供应商' : '修改供应商信息'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="供应商编号：" prop="supplierNo">
          <el-input v-model="ruleForm.supplierNo" :size="size" clearable placeholder="请输入供应商编号"></el-input>
        </el-form-item>
        <el-form-item label="供应商类型：" prop="supplierType">
          <el-select v-model="ruleForm.supplierType" placeholder="请选择供应商类型">
                <el-option
                v-for="item in optionsSupplierType"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="供应商企业名称：" prop="supplierName">
          <el-input v-model="ruleForm.supplierName" :size="size" clearable placeholder="请输入供应商企业名称"></el-input>
        </el-form-item>
        <el-form-item label="法定代表人：" prop="legalPerson">
          <el-input v-model="ruleForm.legalPerson" :size="size" clearable placeholder="请输入法定代表人"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码：" prop="succ">
          <el-input v-model="ruleForm.succ" :size="size" clearable placeholder="请输入统一社会行用代码"></el-input>
        </el-form-item>
        <el-form-item label="联系人：" prop="contact">
          <el-input v-model="ruleForm.contact" :size="size" clearable placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="contactPhone">
          <el-input v-model="ruleForm.contactPhone" :size="size" clearable placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱：" prop="email">
          <el-input v-model="ruleForm.email" :size="size" clearable placeholder="请输入电子邮箱"></el-input>
        </el-form-item>
        <el-form-item label="项目名称：" prop="proIds">
          <el-select v-model="ruleForm.proIds" placeholder="请选择项目名称" multiple>
                <el-option
                v-for="item in optionsProject"
                :key="item.chainProjectId"
                :label="item.chainProjectName"
                :value="item.chainProjectId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="公司地址：" prop="address">
          <el-input v-model="ruleForm.address" :size="size" clearable placeholder="请输入公司地址"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input 
            v-model="ruleForm.remark" 
            :size="size" 
            type="textarea" 
            :rows="2" 
            clearable 
            placeholder="请输入备注"
            maxlength="200"
            show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //供应商管理信息列表
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {
        }, // 按钮表单
        rules: {
          supplierNo: [{
            required: true,
            message: '请输入供应商编号',
            trigger: 'blur'
          }],
          optionsType: [{
            required: true,
            message: '请选择供应商类型',
            trigger: 'change'
          }],
          supplierName: [{
            required: true,
            message: '请输入供应商企业名称',
            trigger: 'blur'
          }],
          legalPerson: [{
            required: true,
            message: '请输入法定代表人',
            trigger: 'blur'
          }],
          succ: [{
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'blur'
          },{
            validator: (rule, value, callback) => {
                const reg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('请输入正确格式'))
                }
            },
            trigger: 'blur'
          }],
          contact: [{
            required: true,
            message: '请输入联系人',
            trigger: 'blur'
          }],
          email: [{
            required: false,
            message: '请输入邮箱',
            trigger: 'blur'
          },{
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: 'blur'
          }],
          contactPhone: [{
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          }],
          address: [{
            required: true,
            message: '请输入公司地址',
            trigger: 'blur'
          }],
          proIds: [{
            required: true,
            message: '请选择项目名称',
            trigger:  'blur'
          }],
        },
        optionsSupplierType:[],//供应商类型
        optionsProject:[],//项目名称
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
      that.getAllTypes()
      that.getAllProjects()
    },
    methods: {
    //table展示项目名称
    showProject(val){
        let str=''
        if(val.length===1){
            str = val[0].proName
        }else{
            val.forEach(item=>{
                str+=item.proName+','
            })
        }
        return str
    },
    //获取所有项目
    getAllProjects(){
        let params = {
            pageNum: 1,
            pageSize: 100000000
        }
        // this.$api.Engineer.searchProjects(params).then(res=>{
        //     if(res.statusMsg === 'ok'){
        //         this.optionsProject = res.data.list
        //     }else{
        //         this.$message.warning(res.statusMsg)
        //     }
        // })
        this.$api.Chain.searchChainProjectList(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.optionsProject = res.data.list;
          }else{
            this.$message.warning(res.statusMsg)
          }
        })
    },
    //获取尺寸配筋转向等信息
      getAllTypes(){
        let params = {
            pageNum: 1,
            pageSize: 100000000
        }
        this.$api.Dictionary.searchDictionary(params).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsSupplierType = res.data.list.filter(item =>item.dictType === '6')
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.$api.Supplier.searchSupplier(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.$api.Supplier.detailsSupplier({supplierId: row.id}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
                let projectArr = []
                res.data.supplierPros.forEach(item=>{
                    projectArr.push(item.proId)
                })
                this.$set(this.ruleForm,'proIds',projectArr)
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Supplier.deleteSupplier({supplierId: row.id})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            this.$api.Supplier.insertSupplier(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            this.$api.Supplier.updateSupplier(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../style/layout-main.scss';
</style>